import { FILTER_IDENTIFIERS } from '../constants/constants';

type ContextEntity = {
    type: string;
    id: string;
};

type FilterExpression = {
    field: string;
    value: {
        values: string[];
    };
};

export type ReportFilter = {
    expressions?: FilterExpression[];
    mustFilters?: ReportFilter[];
    shouldFilters?: ReportFilter[];
};

export const normalizeContextEntities = (contextEntities?: Array<{ type?: string; id?: string }>): ContextEntity[] => {
    return (
        contextEntities
            ?.map((item) => ({
                type: item?.type?.trim(),
                id: item?.id?.trim()
            }))
            .filter((item): item is ContextEntity => Boolean(item.type && item.id)) ?? []
    );
};

export const buildStatusReportsFilter = (
    contextTerm?: string,
    contextEntities?: Array<{ type?: string; id?: string }>
): ReportFilter => {
    const normalizedContextTerm = contextTerm?.trim();
    const normalizedContextEntities = normalizeContextEntities(contextEntities);

    const expressions: FilterExpression[] = [
        ...(normalizedContextTerm
            ? [
                  {
                      field: FILTER_IDENTIFIERS.contextTerm,
                      value: { values: [normalizedContextTerm] }
                  }
              ]
            : [])
    ];

    const contextEntityPairFilters: ReportFilter[] = normalizedContextEntities.map((entity) => ({
        expressions: [
            {
                field: FILTER_IDENTIFIERS.contextEntityType,
                value: { values: [entity.type] }
            },
            {
                field: FILTER_IDENTIFIERS.contextEntityId,
                value: { values: [entity.id] }
            }
        ]
    }));

    const baseFilter: ReportFilter = { expressions };

    if (contextEntityPairFilters.length === 1) {
        baseFilter.mustFilters = [contextEntityPairFilters[0]];
    } else if (contextEntityPairFilters.length > 1) {
        baseFilter.mustFilters = [{ shouldFilters: contextEntityPairFilters }];
    }

    return baseFilter;
};
